// extracted by mini-css-extract-plugin
export default {"root":"aliasChain_root__BBY3g"};